// Badge Animation - Alternate Between Two Texts
class BadgeAnimation extends HTMLElement {
  constructor() {
    super();
    this.toggleState = false;
    this.interval = null;
  }

  connectedCallback() {
    this.badge1 = this.getAttribute('data-badge1') || "";
    this.badge2 = this.getAttribute('data-badge2') || "";

    this.badgeTextEl = this.querySelector('.badge-text');
    if (!this.badgeTextEl) return;

    // Set initial text correctly
    this.badgeTextEl.textContent = this.badge1;

    this.interval = setInterval(() => this.updateText(), 1500);
  }

  updateText() {
    this.classList.add('badge-fade-out');

    setTimeout(() => {
      this.badgeTextEl.textContent = this.toggleState
        ? this.badge1
        : this.badge2;

      this.classList.remove('badge-fade-out');
      this.toggleState = !this.toggleState;
    }, 150); // match CSS duration
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('badge-animation', BadgeAnimation);